'use strict';

const openSupportTicket = pmtElmService => {
	return {
		id: 'supportTicketOpen',
		f: () => {
			pmtElmService.sendData(
				'Navigation.Main',
				'in_Navigation_Main_PinMeToUiSupportTicketOpen',
				null
			);
		}
	};
};

module.exports = {
	openSupportTicket
};
